// @flow
import React from 'react';

import config from '../../config';

type Props = {
  className: string,
};

const PaymentSuccess = (props: Props) => {
  const { className } = props; 
  return (
    <div className={`message-holder ${className}`}>
      <div className="message-wrap">
        <div className="message-title">
          <h2>
            <div className="cir"><i className="icon icon-hg-checked"/></div>
            <div>Your order has been confirmed.</div>
          </h2>
        </div>
        <p>Please check your email for the booking confirmation. Also, please check your spam folder. If you do not receive the ticket within 30 minutes, please email us at <a href={`mailto:${config.honeyguideEmail}`} style={{ color: '#4bc9f7' }}>{config.honeyguideEmail}</a> or call / whatsapp us at <a href={`tel:${config.honeyguidePhoneNumber}`}>{config.honeyguidePhoneNumber}</a>.</p>
      </div>
  </div>
  );
}

PaymentSuccess.defaultProps = {
  className: '',
};

export default PaymentSuccess;



// WEBPACK FOOTER //
// ./src/components/PaymentSuccess/PaymentSuccess.js